module.exports = __webpack_public_path__ + "static/media/play-audio.e51e5357.png";